export enum EPdfOrientation {
  Portrait = 'portrait',
  Landscape = 'landscape',
}

export enum EPdfFitMode {
  Auto = 'auto',
  Page = 'page',
  Width = 'width',
}

export enum EPdfColumnListState {
  Loading = 'loading',
  Empty = 'empty',
  Ready = 'ready',
}

export enum EPdfDocumentLineState {
  Loading = 'loading',
  Exporting = 'exporting',
  Ready = 'ready',
}

export enum EPdfScrollTarget {
  Top = 'top',
  End = 'end',
  Totals = 'totals',
}

export type TPdfAlign = 'left' | 'center' | 'right';

export type TPdfSize = {
  width: number;
  height: number;
};

export type TPdfShares = Record<string, number>;

export type TPdfColumnNode = {
  key: string;
  caption: string;
  visible: boolean;
  isBand: boolean;
  children: TPdfColumnNode[];
};

export type TPdfColumnRow = {
  key: string;
  caption: string;
  depth: number;
  checked: boolean;
  partial: boolean;
  highlighted: boolean;
};

export type TPdfColumnTexts = {
  header: string[];
  body: string[];
};

export type TPdfPageCell = {
  key: string;
  x: number;
  y: number;
  w: number;
  h: number;
  text: string;
  bold: boolean;
  align: TPdfAlign;
  color: string;
  borderColor: string;
  borderWidth: number;
  drawLeftBorder: boolean;
  drawTopBorder: boolean;
  drawRightBorder: boolean;
  drawBottomBorder: boolean;
};

export type TPdfSheetColumn = {
  key: string;
  caption: string;
  share: number;
  x: number;
  w: number;
};

export type TPdfSheetStrip = {
  index: number;
  left: TPdfSheetColumn;
  right: TPdfSheetColumn;
  x: number;
  gripHeight: number;
  gripTop: number;
  chipTop: number;
  valueNow: number;
  valueMin: number;
  valueMax: number;
};

export type TPdfSheetDrag = {
  index: number;
  pointerId: number;
  startX: number;
  left: TPdfSheetColumn;
  right: TPdfSheetColumn;
  base: TPdfShares;
};

export type TPdfViewportMetrics = {
  width: number;
  height: number;
  scrollLeft: number;
  scrollTop: number;
  sheetLeft: number;
  sheetTop: number;
};

export type TPdfVisibleWindow = {
  x: number;
  y: number;
  width: number;
  height: number;
};

export type TPdfPoint = {
  x: number;
  y: number;
};

export type TPdfFitButton = {
  icon: string;
  label: string;
};

export type TPdfStyle = Record<string, string>;
